'use client';

import { useCallback, useEffect } from 'react';
import ReactGtmModule from 'react-gtm-module';

import { gtmId, ymId } from '@/global';
import { useAnalytics } from '@/hooks/useAnalytics';
import { useRouteChangeEvent } from '@/hooks/useRouteChangeEvent';
import { getUtmFromUrl } from '@/utils/getUtmFromUrl';
import { metricClient } from "@/utils/metricClient";

declare global {
  interface Window {
    // Потому что нет достоверного типа от ym
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ym?: (...args: any[]) => void;
  }
}

const CustomApp = ({ children }: { children: React.ReactNode }) => {
  const { pageViewCustom } = useAnalytics();

  useEffect(() => {
    if (document) {
      const tagManagerArgs = {
        gtmId: gtmId,
        dataLayerName: 'dataLayer',
        dataLayer: {
          originalLocation: document.location.href,
        },
      };
      //
      ReactGtmModule.initialize(tagManagerArgs);

      // Инициализация metricClient в dev (ym)
      // prod ym находится в layout
      // process.env.NEXT_PUBLIC_SPACE !== 'production' &&
      //   metricClient.initialize();
    }
  }, []);

  useEffect(() => {
    if (document) {
      metricClient.initialize();
    }
  }, []);

  useEffect(() => {
    if (window) {
      if (getUtmFromUrl(window.location.href) === '') return;
      window.localStorage.setItem(
        'originalUTM',
        getUtmFromUrl(window.location.href),
      );
    }
  }, []);

  useEffect(() => {
    const mindboxInit = `
      mindbox = window.mindbox || function() { mindbox.queue.push(arguments); };
      mindbox.queue = mindbox.queue || [];
      mindbox('create');
      `;
    const mindboxInitFunction = new Function(mindboxInit);
    process.env.NEXT_PUBLIC_SPACE === 'production' && mindboxInitFunction();
  }, []);

  // ym hit событие pageview для spa сайтов
  const handleRouteChange = useCallback(() => {
    if (window && window.ym) {
      pageViewCustom();
      window.ym(ymId, 'hit', window.location.href, {
        params: {
          title: document.title,
          referer: document.referrer,
        },
      });
    }
  }, [pageViewCustom]);

  // ym hit на 1 заход
  useEffect(() => {
    handleRouteChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ym hit на все страницы кроме 1 захода
  useRouteChangeEvent(() => {
    handleRouteChange();
  });

  return <>{children}</>;
};

export { CustomApp };
